import { ConfigType, type ConfigEntity } from '../types/config'

// One key per config entity: two entities are the same config when it matches.
export const entityKey = (entity: ConfigEntity) =>
  [entity.type, entity.customer, entity.job, entity.folder_path, entity.table_name].map((part) => part ?? '').join('|')

/**
 * The config entity of a saved table, from its path, split the way Insights
 * reads it (goapi chat.go: "a/b/table.cbt" → folder "a/b", table "table").
 * Null when the path has no folder (a new table, an AutoCoder table, a table
 * at the root): Insights reads the job's context there, and a table config
 * needs a folder.
 */
export const tableConfigEntity = (
  customer: string | null | undefined,
  job: string | null | undefined,
  tablePath: string | null | undefined,
): ConfigEntity | null => {
  if (!customer || !job || !tablePath) return null
  const parts = tablePath.replace(/^\/+/, '').split('/')
  const tableName = (parts.pop() || '').replace(/\.cbt$/, '')
  const folderPath = parts.join('/')
  if (!folderPath || !tableName) return null
  return {
    type: ConfigType.Table,
    customer,
    job,
    folder_path: folderPath,
    table_name: tableName,
    display_name: `Table: ${tableName}`,
  }
}
